import { omit } from "lodash";
import { RouteObject } from "react-router-dom";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";

export type UclRouteObject = RouteObject & {
  label: string;
  icon?: IconDefinition;
  isAvailable?: boolean;
  showInNavigation?: boolean;
  showInSubNavigation?: boolean;
  parentRoute?: UclRouteObject;
  containerKey?: string;
  children?: UclRouteObject[];
};

export const findRouteByPath = (
  route: UclRouteObject,
  path: string,
  parentPath?: string
): UclRouteObject | undefined => {
  if (
    route.path === path ||
    route.path === `/${path}` ||
    (parentPath &&
      path === `${parentPath ?? ""}/${route.path}`.replace("//", "/"))
  ) {
    return route;
  } else {
    if (route.children) {
      for (const child of route.children as UclRouteObject[]) {
        const result = findRouteByPath(child, path, route.path);
        if (result) {
          result.parentRoute = omit(route, ["children"]);
          return result;
        } else {
          const result2 = findRouteByPath(child, path, route.path);
          if (result2) {
            return result2;
          }
        }
      }
    }
    return undefined;
  }
};

export const findRoute = (
  routes: UclRouteObject[],
  path: string
): UclRouteObject | undefined => {
  for (const route of routes.filter(
    (r) => r.children && r.children.length > 0
  )) {
    const result = findRouteByPath(route, path);
    if (result) {
      return result;
    }
  }
  return undefined;
};
